import { render } from "./slotDateDeadlineComponent.vue?vue&type=template&id=2ca91264"
import script from "./slotDateDeadlineComponent.vue?vue&type=script&lang=js"
export * from "./slotDateDeadlineComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__